module.exports = {"buildVersion":"2.17.14-220513169","release":"2.17.14","buildDateTime":"Fri May 13 2022 05:38"}


//////////////////
// WEBPACK FOOTER
// ./src/metadata.json
// module id = 2099
// module chunks = 23